const { useState, useEffect, useRef } = React;
import { useAnimIn, useMinheight } from "./../utils";

function SetPassword ({
    registeredEmail,
    handleZephrAccCreation,
    userPassword,
    setUserPassword,
    errorMessage,
    isBusy,
    isSuccess,
    hasZephrUser,
    dismissSignUp,
    setPasswordIsStrong,
    passwordIsStrong
}) {

    const ref = useRef();
    useAnimIn(ref, { delay: 500, translateY: [ 50, 0 ] });
    return (
        <div ref={ ref } className="mx-n4 py-md-4 p-4 bg-light-subtle border-top">
            {
                isSuccess ? (
                    <ElAnimIn>
                        <h4 className="font-heading h3 mb-4 text-center text-success">
                            Almost there!
                        </h4>
                        <p className="text-sm text-center">You have been sent an email to <span className="bg-light border text-sm fw-medium p-1" style={ { wordBreak: "break-word" } }>{ registeredEmail }</span> to verify your account.</p>
                    </ElAnimIn>
                ) : hasZephrUser ? (
                    <ElAnimIn>
                        <h4 className="font-heading h3 mb-4 text-center">
                            You already have an ADWEEK account.
                        </h4>
                        <p className="text-sm text-center">Sign in to access your account with <span className="bg-light border text-sm fw-medium p-1" style={ { wordBreak: "break-word" } }>{ registeredEmail }</span>.</p>
                    </ElAnimIn>
                ) : (
                    <ElAnimIn>
                        <h4 className="h3 mb-0 text-center font-heading mb-3">
                            Finish setting up your free <span className="text-aw-webinar">ADWEEK </span>account.
                        </h4>
                        <p className="mb-4 text-sm">
                            Gain limited access to Adweek.com articles, videos and podcasts. PLUS, the Adweek Daily newsletter with must-read stories will be sent directly to your inbox.
                        </p>
                        <div>
                            <label className=" mb-2 pb-0 text-sm">
                                Email
                            </label>
                            <input
                                type="text"
                                className=" text-sm form-control"
                                value={ registeredEmail }
                                readOnly
                                disabled
                            />
                        </div>

                        <div>
                            <label className="mt-3 mb-2 pb-0 text-sm">
                                Password
                            </label>
                            <input
                                className="form-control"
                                onChange={ (e) => setUserPassword(e.target.value) }
                                type="password"
                                onKeyUp={ e => e.key === 'Enter' && passwordIsStrong && !isBusy ? handleZephrAccCreation() : null }
                            />
                        </div>

                        <PasswordReguirements setPasswordIsStrong={ setPasswordIsStrong } userPassword={ userPassword } />

                        <div className="mt-4">
                            <BtnCreateAccount isBusy={ isBusy } disabled={ !userPassword?.length || !passwordIsStrong } handleZephrAccCreation={ handleZephrAccCreation } />
                            <button
                                type="button"
                                className="btn btn-link text-secondary text-decoration-none ml-2"
                                onClick={ dismissSignUp }
                            >
                                No thanks
                            </button>
                        </div>
                    </ElAnimIn>
                )
            }

            { errorMessage && <ErrorMessage message={ errorMessage } /> }

        </div>
    );
}

export default SetPassword;

const PasswordReguirements = ({ setPasswordIsStrong, userPassword }) => {

    const [ hasUpperCase, setHasUpperCase ] = useState(false);
    const [ hasSpecialChar, setHasSpecialChar ] = useState(false);
    const [ hasNumber, setHasNumber ] = useState(false);
    const [ hasLength, setHasLength ] = useState(false);

    useEffect(() => {
        hasUpperCase && hasSpecialChar && hasNumber && hasLength ? setPasswordIsStrong(true) : setPasswordIsStrong(false);
    }, [ hasUpperCase, hasSpecialChar, hasNumber, hasLength ]);

    useEffect(() => {
        const hasUpperCase = /[A-Z]/.test(userPassword);
        setHasUpperCase(hasUpperCase);

        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(userPassword);
        setHasSpecialChar(hasSpecialChar);

        const hasNumber = /[0-9]/.test(userPassword);
        setHasNumber(hasNumber);

        const hasLength = userPassword?.length >= 8;
        setHasLength(hasLength);
    }, [ userPassword ]);

    return (
        <div className="mt-4 text-sm">
            <span className="font-weight-bold text-secondary">
                Password must contain:
            </span>
            <span className={ `d-flex ${hasLength ? 'text-success ' : 'text-secondary'}` }>
                At least 8 characters <Check show={ hasLength } />
            </span>
            <span className={ `d-flex ${hasUpperCase ? 'text-success ' : 'text-secondary'}` }>
                1 uppercase <Check show={ hasUpperCase } />
            </span>
            <span className={ `d-flex ${hasNumber ? 'text-success ' : 'text-secondary'}` }>
                1 number <Check show={ hasNumber } />
            </span>
            <span className={ `d-flex ${hasSpecialChar ? 'text-success ' : 'text-secondary'}` }>
                1 special character <Check show={ hasSpecialChar } />
            </span>
        </div>
    );
};

const Check = ({ show }) => {

    const ref = useRef();

    const prevShowVal = React.useRef(show);
    let tl = null;
    if (typeof anime === 'function') {
        tl = anime.timeline({
            easing: 'easeInOutQuad',
            duration: 300,
        });
    }

    useEffect(() => {
        if (tl === null) {

        }
        if (typeof anime === 'function' && show !== prevShowVal.current) {

            tl.add({
                targets: ref?.current,
                opacity: show ? [ 0, 1 ] : [ 1, 0 ],
                translateX: show ? [ 10, 0 ] : [ 0, 10 ],
            });

        }
        prevShowVal.current = show;

    }, [ show ]);

    return (
        <svg ref={ ref } height="24" viewBox="0 -960 960 960" width="24"
            style={ { opacity: 0 } }
        >
            <path fill="currentColor" d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z" />
        </svg>
    );
};

const BtnCreateAccount = ({ handleZephrAccCreation, disabled, isBusy }) => {

    const ref = useRef();
    useMinheight(ref);
    return (
        <button
            ref={ ref }
            disabled={ disabled || isBusy }
            onClick={ handleZephrAccCreation }
            className="webinar-create-account-btn btn rounded-0 border border-aw-webinar
                text-aw-webinar text-decoration-none px-3 py-2 text-uppercase bg-white font-weight-bold text-small"
        >
            { isBusy ? "Creating" : "Create Account" }
        </button>
    );
};

const ErrorMessage = ({ message }) => {
    const ref = useRef();
    useAnimIn(ref);
    return (
        <div ref={ ref } className="alert alert-warning  mt-4" role="alert">{ message }</div>
    );
};

const ElAnimIn = ({ children }) => {
    const ref = useRef();
    useAnimIn(ref);
    return (
        <div ref={ ref }>
            { children }
        </div>
    );
};